import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StarOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { fetchProjectRating } from 'api/project-api';
import { useSession } from 'components/Authenticated';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { txt } from 'libs/i18n';
import styles from './style.module.less';
import ProjectRatingModal from '../../DocumentEditor/ProjectRatingModal';
import { useEditorContext } from '../../contexts/projectSignal';
const ProjectRating = ({ projectInProgress }) => {
    const { session } = useSession();
    const { projectSignal } = useEditorContext();
    const projectId = projectSignal.value.id;
    const [userFeedbackVisible, setUserFeedbackVisible] = useState(false);
    const [projectRating, setProjectRating] = useState('loading');
    useEffect(() => {
        const fetchProjectRatingState = async () => {
            const rating = await fetchProjectRating(session.connection, projectId);
            setProjectRating(rating);
        };
        void fetchProjectRatingState();
    }, []);
    const handleRatingSubmit = (rating) => {
        setProjectRating(rating);
        setUserFeedbackVisible(false);
    };
    return (_jsxs(_Fragment, { children: [!projectInProgress && (_jsxs(Button, { type: "primary", size: "small", loading: projectRating === 'loading', disabled: projectRating !== null, className: clsx(styles.ratingButton, { [styles.wiggleAnimation]: projectRating === null }), onClick: () => setUserFeedbackVisible(true), children: [_jsx(StarOutlined, {}), projectRating !== 'loading' ? (projectRating === null ? txt('rating') : (_jsx("span", { children: projectRating.score }))) : null] })), _jsx(ProjectRatingModal, { projectId: projectId, onSubmit: handleRatingSubmit, visible: userFeedbackVisible, onClose: () => setUserFeedbackVisible(false) })] }));
};
export default ProjectRating;
